import { combineLatest, Observable } from "rxjs";
import { map, catchError } from "rxjs/operators";
import { Geocoder } from "./geocoder";
import { of } from "rxjs";
export class DispatchGeocoder extends Geocoder {
    _geocoders = [];
    constructor(inputField) {
        super(inputField);
    }
    get query$() {
        const queries = [];
        for (const geocoder of this._geocoders) {
            queries.push(geocoder.query$.pipe(catchError((error) => {
                console.warn(error.message);
                return of([]);
            })));
        }
        const query$ = combineLatest(queries).pipe(map((locations) => {
            const flat_locations = [];
            const n_per_array = Math.floor(10 / locations.length);
            for (const location_array_key in locations) {
                const location_array = locations[parseInt(location_array_key)];
                if (typeof location_array == "string") {
                    continue;
                }
                for (const location of location_array.slice(0, n_per_array)) {
                    if (location.locationId.split("-|-").length == 1)
                        location.locationId = `${location_array_key}-|-${location.locationId}`;
                    flat_locations.push(location);
                }
            }
            flat_locations.sort((a, b) => b.score - a.score);
            return flat_locations;
        }));
        return query$;
    }
    select(locationId) {
        const [geocoder_key, locationId_internal] = locationId.split("-|-");
        return this._geocoders[parseInt(geocoder_key)].select(locationId_internal);
    }
    registerGeocoder(geocoder) {
        this._geocoders.push(geocoder);
    }
    _getDefaultConfiguration() {
        return {};
    }
}
//# sourceMappingURL=dispatchgeocoder.js.map